import { columnHelper } from './helper';

export const driver = columnHelper.accessor('Driver', {
  header: 'Driver',
  id: 'driver',
});
